export default __webpack_public_path__ + "static/media/sourcetree.56b4280b.svg";